import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Input } from 'antd';

const NumericInputEditor = forwardRef((props: any, ref) => {
    const inputRef = useRef<any>(null);

    useImperativeHandle(ref, () => ({
        getValue: () => {
            const value = inputRef.current?.input?.value ?? '';
            const parsed = parseFloat(value);
            return isNaN(parsed) ? null : parsed;
        },
        afterGuiAttached: () => {
            setTimeout(() => inputRef.current?.focus(), 0);
        }
    }));

    return (
        <Input
            ref={inputRef}
            defaultValue={props.value}
            min={0}
            step="any"
            className="custom-transparent-input"
            onWheel={(e) => e.currentTarget.blur()}
            onKeyDown={(e) => {
                if (!/^[0-9.]$/.test(e.key) && !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                    e.preventDefault();
                }
            }}
        />
    );
});

export default NumericInputEditor;
